/* eslint-disable */
export default {
  dialPlaceholder: 'Enter name or number',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
